/** @format */

module.exports = {
  publicKey: "fb0b8e46009a7302412536bde8f021cc",
  hostnameId: "mybet",
};



// WEBPACK FOOTER //
// ./src/partners/config/partner.js